import { render, staticRenderFns } from "./transformer-create.vue?vue&type=template&id=2c99a4e6"
import script from "./transformer-create.vue?vue&type=script&lang=js"
export * from "./transformer-create.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports